import React from 'react';
import { loggedIn } from "../../actions";
import { connect } from "react-redux";
import { Redirect, } from 'react-router-dom'
import auth0Client from './Auth';
import {setCookie, deleteCookie} from '../../utils/utils'
import Background from '../../utils/images/banner1-1.jpg'
import WhiteLogo from '../../utils/images/logo-white.png'
import './LoginStyle.css'

import {
  State
} from "../../types";

type myProps = {
  dispatch: Function
};

type myState = { 
                isLogged: boolean
               };

export const Login = connect((state: State, ownProps: any) => {
  return {
      loginStatus: state.login.isLogged
  }
})

(class Login extends React.Component<myProps, myState> {
constructor(props: any){
  super(props);
  this.state={
  isLogged: false,
  }
 }

render() {

    if(auth0Client.isAuthenticated()){
      console.log("Logged")
      window.localStorage['isLogged']= true;
      this.setState({isLogged: true}); 
      const { dispatch } = this.props;
      dispatch(loggedIn());
      const token = auth0Client.getIdToken();
      setCookie("auth_token", token)   
      return (<Redirect to={'/selectcamera'} push/>)
    }
    if(!auth0Client.isAuthenticated()){
      window.localStorage['isLogged']= false;
      deleteCookie("auth_token");
    }
    return (
      <div>
        {
          !auth0Client.isAuthenticated() &&
          <div>
            <div className="container-login">
                <img className="top-left" src={Background}  style={backgroundImageStyle}/>
                <img className="top-left" src={WhiteLogo}/>
                <div className="top-right" style={{cursor:"pointer"}} onClick={auth0Client.signIn}>Login</div>
            </div> 
          </div>
        }

      </div>
    );
    
  }
});

const backgroundImageStyle = {
  width: "100vw",
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.tsx